import cruiseVideo from "../assets/ride/generated/anvesho-seedance-auto-ride-test-02-web.mp4";
import mobileRideVideo from "../assets/ride/generated/anvesho-mobile-ride-master-4x3.mp4";
import cruiseMobilePoster from "../assets/ride/generated/anvesho-seedance-auto-ride-test-02-mobile-4x3-poster.jpg";
import liveMusicVideo from "../assets/ride/generated/anvesho-discovery-live-music-01-web.mp4";
import liveMusicMobilePoster from "../assets/ride/generated/anvesho-discovery-live-music-01-mobile-4x3-poster.jpg";
import foodVideo from "../assets/ride/generated/anvesho-discovery-hidden-food-01-web.mp4";
import foodMobilePoster from "../assets/ride/generated/anvesho-discovery-hidden-food-01-mobile-4x3-poster.jpg";
import potteryVideo from "../assets/ride/generated/anvesho-discovery-pottery-workshop-01-web.mp4";
import potteryMobilePoster from "../assets/ride/generated/anvesho-discovery-pottery-workshop-01-mobile-4x3-poster.jpg";
import greenVideo from "../assets/ride/generated/anvesho-discovery-green-escape-01-web.mp4";
import greenMobilePoster from "../assets/ride/generated/anvesho-discovery-green-escape-01-mobile-4x3-poster.jpg";
import fleaVideo from "../assets/ride/generated/anvesho-discovery-flea-market-01-web.mp4";
import fleaMobilePoster from "../assets/ride/generated/anvesho-discovery-flea-market-01-mobile-4x3-poster.jpg";
import courtyardImage from "../assets/ride/music-courtyard.png";

export const cruise = {
  id: "cruise",
  video: cruiseVideo,
  mobileVideo: mobileRideVideo,
  mobilePoster: cruiseMobilePoster,
  mobileStart: 0,
};

export const discoveries = [
  {
    id: "live-music",
    icon: "♪",
    type: "Live music",
    video: liveMusicVideo,
    mobileVideo: mobileRideVideo,
    mobilePoster: liveMusicMobilePoster,
    mobileStart: 5,
    noticeAt: 4.15,
    cruiseAfter: 3.8,
    cruiseOffset: 0,
    eyebrow: "HEAR THAT?",
    title: "A little acoustic, a little unplanned.",
    meta: "Tonight · 7:30 PM · nearby",
    detailTitle: "A little acoustic, a little unplanned.",
    category: "Live music",
    time: "Tonight, 7:30 pm",
    distance: "700 m",
    price: "Around Rs 500",
    shortDescription: "A small acoustic session tucked into the evening.",
    note: "For the evening you left open. Pull up a chair, order something cold, and stay for a song or three.",
    poster: courtyardImage,
    posterAlt: "An intimate acoustic courtyard with warm lights and seated listeners.",
  },
  {
    id: "hidden-food",
    icon: "🍜",
    type: "Hidden food",
    video: foodVideo,
    mobileVideo: mobileRideVideo,
    mobilePoster: foodMobilePoster,
    mobileStart: 15,
    noticeAt: 4.1,
    cruiseAfter: 4,
    cruiseOffset: 0.2,
    eyebrow: "FOLLOW THE STEAM",
    title: "Something good is happening on that tawa.",
    meta: "Open now · nearby · ₹",
    detailTitle: "Something good is happening on that tawa.",
    category: "Food",
    time: "Open now",
    distance: "Nearby",
    price: "₹",
    shortDescription: "Steam, regulars and the kind of queue that usually knows something.",
    note: "This is the stop for when the plan was only to look around, but the tawa had other ideas.",
  },
  {
    id: "pottery",
    icon: "○",
    type: "Workshop",
    video: potteryVideo,
    mobileVideo: mobileRideVideo,
    mobilePoster: potteryMobilePoster,
    mobileStart: 25,
    noticeAt: 4.15,
    cruiseAfter: 3.5,
    cruiseOffset: 0.4,
    eyebrow: "MAKE SOMETHING",
    title: "Trade scrolling for clay.",
    meta: "Workshop nearby · Today",
    detailTitle: "Trade scrolling for clay.",
    category: "Workshop",
    time: "Today",
    distance: "Nearby",
    price: "Ticketed",
    shortDescription: "A hands-on studio session with clay, wheels and a slower kind of evening.",
    note: "Good for beginners, better for anyone whose week has involved too many screens.",
  },
  {
    id: "green-escape",
    icon: "🌿",
    type: "Green escape",
    video: greenVideo,
    mobileVideo: mobileRideVideo,
    mobilePoster: greenMobilePoster,
    mobileStart: 35,
    noticeAt: 4.2,
    cruiseAfter: 4,
    cruiseOffset: 0.15,
    eyebrow: "WHITEFIELD WENT QUIET",
    title: "Take the slower route.",
    meta: "Sunset walk · Nearby · Free",
    detailTitle: "Five minutes from traffic. Somehow.",
    category: "Green escape",
    time: "Sunset",
    distance: "Nearby",
    price: "Free",
    shortDescription: "A calmer stretch for walking, breathing and remembering the city still has edges.",
    note: "Not a ticketed plan. Just somewhere to let the evening cool down a little.",
    driverLine: "Gets quieter here.",
  },
  {
    id: "flea-market",
    icon: "✦",
    type: "Pop-up market",
    video: fleaVideo,
    mobileVideo: mobileRideVideo,
    mobilePoster: fleaMobilePoster,
    mobileStart: 45,
    noticeAt: 4.15,
    cruiseAfter: 2.8,
    cruiseOffset: 0.7,
    eyebrow: "WORTH A LOOK",
    title: "This wasn't here yesterday.",
    meta: "Neighbourhood pop-up · This evening",
    detailTitle: "Not everything worth finding has a storefront.",
    category: "Market",
    time: "This evening",
    distance: "Nearby",
    price: "Browse",
    shortDescription: "Small stalls, warm lights and the nice risk of finding something you did not need.",
    note: "A soft landing for people who like browsing more than shopping malls.",
  },
];

export const rideVideos = [cruise.video, ...discoveries.map((item) => item.video)];
export const mobileRideVideos = [mobileRideVideo];
